<div class="modal-header">
  <h5 class="modal-title">Punkte importieren</h5>
  <button type="button" class="btn-close" aria-label="Schließen" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <!-- Schritt 1: Dateiauswahl -->
  <div *ngIf="step === 'select'" class="step-content">
    <div class="file-section">
      <h6>Excel-Protokolle (Bohrpunkt / Moorpunkt)</h6>
      <p class="text-muted small">Unterstützte Formate: .xlsx, .xls, .xlsm, .xlsb</p>

      <div class="file-input-wrapper">
        <input type="file"
               id="excelInput"
               accept=".xlsx,.xls,.xlsm,.xlsb"
               multiple
               (change)="onExcelFilesSelected($event)"
               class="file-input">
        <label for="excelInput" class="btn btn-outline-primary">
          <span class="bi bi-file-earmark-excel"></span> Excel-Dateien auswählen
        </label>
      </div>

      <ul class="file-list" *ngIf="excelFiles.length > 0">
        <li *ngFor="let file of excelFiles; let i = index">
          <span class="filename">{{ file.name }}</span>
          <span class="filesize">({{ (file.size / 1024).toFixed(1) }} KB)</span>
          <button type="button" class="btn btn-sm btn-link text-danger" (click)="removeExcelFile(i)">
            <span class="bi bi-x"></span>
          </button>
        </li>
      </ul>
    </div>

    <div class="file-section">
      <h6>GeoPackage / Shapefile</h6>
      <p class="text-muted small">Punkte mit Koordinaten und Basisattributen</p>

      <div class="file-input-wrapper">
        <input type="file"
               id="gpkgInput"
               accept=".gpkg,.shp,.geojson,.json"
               multiple
               (change)="onGpkgFilesSelected($event)"
               class="file-input">
        <label for="gpkgInput" class="btn btn-outline-secondary">
          <span class="bi bi-geo-alt"></span> Geodaten auswählen
        </label>
      </div>

      <ul class="file-list" *ngIf="gpkgFiles.length > 0">
        <li *ngFor="let file of gpkgFiles; let i = index">
          <span class="filename">{{ file.name }}</span>
          <span class="filesize">({{ (file.size / 1024).toFixed(1) }} KB)</span>
          <button type="button" class="btn btn-sm btn-link text-danger" (click)="removeGpkgFile(i)">
            <span class="bi bi-x"></span>
          </button>
        </li>
      </ul>
    </div>
  </div>

  <!-- Schritt 1b: Layer-Auswahl für GeoPackage -->
  <div *ngIf="step === 'select-layer'" class="step-content">
    <div class="alert alert-info">
      <span class="bi bi-info-circle"></span>
      Einige GeoPackage-Dateien enthalten mehrere Punkt-Layer. Bitte wählen Sie den gewünschten Layer aus.
    </div>

    <div *ngFor="let choice of gpkgLayerChoices" class="layer-choice mb-3">
      <h6>{{ choice.file.name }}</h6>
      <select class="form-select" [(ngModel)]="choice.selectedLayer">
        <option *ngFor="let layer of choice.layers" [value]="layer">{{ layer }}</option>
      </select>
    </div>
  </div>

  <!-- Schritt 2: Analyse -->
  <div *ngIf="step === 'analyzing'" class="step-content text-center">
    <div class="spinner-border text-primary mb-3" role="status">
      <span class="visually-hidden">Analysiere...</span>
    </div>
    <p>{{ progressText }}</p>
    <ngb-progressbar [value]="progress" [striped]="true" [animated]="true"></ngb-progressbar>
  </div>

  <!-- Schritt 3: Vorschau -->
  <div *ngIf="step === 'preview'" class="step-content">
    <!-- Zusammenfassung -->
    <div class="validation-summary mb-3" *ngIf="validationSummary">
      <div class="row text-center">
        <div class="col">
          <div class="summary-card success"
               [class.active]="displayFilter === 'success'"
               (click)="toggleFilter('success')"
               style="cursor: pointer;">
            <div class="summary-number">{{ validationSummary.successCount }}</div>
            <div class="summary-label">Fehlerfrei</div>
          </div>
        </div>
        <div class="col">
          <div class="summary-card warning"
               [class.active]="displayFilter === 'warning'"
               (click)="toggleFilter('warning')"
               style="cursor: pointer;">
            <div class="summary-number">{{ validationSummary.warningCount }}</div>
            <div class="summary-label">Mit Warnungen</div>
          </div>
        </div>
        <div class="col">
          <div class="summary-card error"
               [class.active]="displayFilter === 'error'"
               (click)="toggleFilter('error')"
               style="cursor: pointer;">
            <div class="summary-number">{{ validationSummary.errorCount }}</div>
            <div class="summary-label">Mit Fehlern</div>
          </div>
        </div>
      </div>

      <div class="mt-2 text-end">
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="saveImportLog()">
          <i class="bi bi-download me-1"></i>Protokoll speichern
        </button>
      </div>
    </div>

    <!-- Detaillierte Ergebnisse -->
    <div class="validation-details">
      <div *ngFor="let file of parsedFiles" class="file-result">
        <h6 class="file-header">{{ file.filename }}</h6>

        <div *ngFor="let sheet of file.sheets" class="sheet-result"
             [class.valid]="sheet.validation.isValid && !sheet.validation.hasWarnings"
             [class.warning]="sheet.validation.isValid && sheet.validation.hasWarnings"
             [class.error]="!sheet.validation.isValid"
             [hidden]="!sheetMatchesFilter(sheet)">

          <div class="sheet-header">
            <span class="sheet-icon">
              <span *ngIf="sheet.validation.isValid && !sheet.validation.hasWarnings" class="bi bi-check-circle-fill text-success"></span>
              <span *ngIf="sheet.validation.isValid && sheet.validation.hasWarnings" class="bi bi-exclamation-triangle-fill text-warning"></span>
              <span *ngIf="!sheet.validation.isValid" class="bi bi-x-circle-fill text-danger"></span>
            </span>
            <span class="sheet-name">Blatt {{ sheet.name }}</span>
            <span class="sheet-format badge"
                  [class.bg-primary]="sheet.format === 'bohrpunkt'"
                  [class.bg-info]="sheet.format === 'moorpunkt'"
                  [class.bg-secondary]="sheet.format === 'unknown'">
              {{ sheet.format === 'bohrpunkt' ? 'Bohrpunkt' : sheet.format === 'moorpunkt' ? 'Moorpunkt' : 'Unbekannt' }}
            </span>
            <span *ngIf="sheet.data" class="sheet-info text-muted">
              {{ sheet.data.header ? sheet.data.header.nummer || '(ohne Nummer)' : '(ohne Nummer)' }}
            </span>
          </div>

          <ul class="validation-messages" *ngIf="sheet.validation.messages.length > 0">
            <li *ngFor="let msg of sheet.validation.messages"
                [class.error]="msg.severity === 'error'"
                [class.warning]="msg.severity === 'warning'"
                [class.info]="msg.severity === 'info'">
              <strong>{{ msg.field }}:</strong> {{ msg.message }}
              <span *ngIf="msg.value" class="msg-value">(Wert: "{{ msg.value }}")</span>
              <span *ngIf="msg.suggestion" class="msg-suggestion">→ {{ msg.suggestion }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Import-Optionen -->
    <div class="import-options mt-3">
      <h6>Import-Optionen</h6>

      <div class="form-check">
        <input type="checkbox" class="form-check-input" id="importValid" [(ngModel)]="importOptions.importValid">
        <label class="form-check-label" for="importValid">
          Fehlerfreie Punkte importieren ({{ validationSummary?.successCount || 0 }})
        </label>
      </div>

      <div class="form-check">
        <input type="checkbox" class="form-check-input" id="importWarnings" [(ngModel)]="importOptions.importWithWarnings">
        <label class="form-check-label" for="importWarnings">
          Punkte mit Warnungen importieren ({{ validationSummary?.warningCount || 0 }})
        </label>
      </div>

      <div class="mt-2" *ngIf="duplicates.length > 0">
        <label class="form-label">Bei Duplikaten:</label>
        <select class="form-select form-select-sm" [(ngModel)]="importOptions.duplicateAction">
          <option value="skip">Überspringen</option>
          <option value="update">Bestehenden Punkt aktualisieren</option>
          <option value="keep_both">Beide behalten</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Schritt 4: Import läuft -->
  <div *ngIf="step === 'importing'" class="step-content text-center">
    <div class="spinner-border text-primary mb-3" role="status">
      <span class="visually-hidden">Importiere...</span>
    </div>
    <p>{{ progressText }}</p>
    <ngb-progressbar [value]="progress" [striped]="true" [animated]="true"></ngb-progressbar>
  </div>

  <!-- Schritt 5: Abgeschlossen -->
  <div *ngIf="step === 'complete'" class="step-content text-center">
    <div class="complete-icon mb-3">
      <span class="bi bi-check-circle-fill text-success" style="font-size: 4rem;"></span>
    </div>
    <h5>Import abgeschlossen</h5>
    <p class="text-muted">
      {{ importedCount }} Punkte importiert<br>
      <span *ngIf="skippedCount > 0">{{ skippedCount }} übersprungen</span>
    </p>
    <button type="button" class="btn btn-outline-secondary btn-sm mt-2" (click)="saveImportLog()">
      <i class="bi bi-download me-1"></i>Protokoll speichern
    </button>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()" *ngIf="step !== 'complete'">
    Abbrechen
  </button>

  <button type="button" class="btn btn-primary"
          *ngIf="step === 'select'"
          [disabled]="!hasFiles"
          (click)="startAnalysis()">
    Analysieren
  </button>

  <button type="button" class="btn btn-primary"
          *ngIf="step === 'select-layer'"
          (click)="continueAfterLayerSelection()">
    Weiter
  </button>

  <button type="button" class="btn btn-primary"
          *ngIf="step === 'preview'"
          [disabled]="pointsToImport === 0"
          (click)="startImport()">
    {{ pointsToImport }} Punkte importieren
  </button>

  <button type="button" class="btn btn-primary"
          *ngIf="step === 'complete'"
          (click)="close()">
    Schließen
  </button>
</div>
